import useModal from '@carvana/ds-modal';
import React, { useEffect } from 'react';
import { StepElement } from '|/app/purchase/flow/steps-router';
import { Step } from '|/app/services';
import { NextStepNavigationContextProvider, PageEventContextProvider } from '|/context';
import { AppFrameworkContextProvider } from '|/helpers/app-framework';
import styles from './verification-task-sheet.module.css';
import { getPageEventContext } from '../constants/page-event-mappings';

interface VerificationTaskSheetProps {
  step: Step;
  onSubmit: () => void;
  onClose: () => void;
}

const VerificationTaskSheet: React.FC<VerificationTaskSheetProps> = ({
  step,
  onSubmit,
  onClose
}) => {
  const { Modal, openModal } = useModal();

  useEffect(() => {
    openModal();
  }, [openModal]);

  return (
    <Modal
      modalHeader={step.name}
      onClose={onClose}
      disableOutsideClose
      disableEscapeClose
      contentPadding={false}
      zIndex={700}
      classes={{ body: styles.modalBody }}
    >
      <PageEventContextProvider value={getPageEventContext(step.id)}>
        <NextStepNavigationContextProvider
          value={{ handleNextStep: onSubmit, ensureInProgress: () => Promise.resolve() }}
        >
          <AppFrameworkContextProvider>
            <StepElement
              step={step}
              isHidden={false}
              GetDashboardAndRouteToNextStep={() => {
                onSubmit();
              }}
            />
          </AppFrameworkContextProvider>
        </NextStepNavigationContextProvider>
      </PageEventContextProvider>
    </Modal>
  );
};

export default VerificationTaskSheet;
